import React from 'react';
import { Link, } from 'react-router';
import { Pagination, } from 'react-bootstrap';
import Header from './Layout/Header';
import { format } from 'date-fns';
import $ from 'jquery';
import '../../public/css/media/_track-package.scss';
import Footer from './Layout/Footer/Footer';
import { numbersWithComma, maskLocationName, netcoreScript } from '../utils/utils';

const createReactClass = require('create-react-class');
const TrackPackage = createReactClass({

  componentDidMount() {
    window.scrollTo(0, 0);
    // <!-- NetCore Script -->
    const accountNumber = this.props.login.fetched && this.props.login.login && this.props.login.login.party && this.props.login.login.party.account_number ? this.props.login.login.party.account_number : '' ;
    window.smartech && netcoreScript(accountNumber);
    // <!-- NetCore Script -->  
  },
  getInitialState() {
    return {
      activePage: 1,
      per_page: 10,
      status: 'confirmed,in_transit,delivered,for_pickup,consolidated,out_for_delivery,failed_delivery,for_consolidation,claimed,picked_up,failed_pickup,return_in_transit,returned,failed_return,for_acceptance,accepted,for_transfer,out_for_return,for_dropoff,dropped_off,received_at_delivery_hub,received_at_delivery_area,at_sorting_center,dws_update',
      range: "3months",
      footerLinks: ["2", "3", "4", "7",],
      bottomNavLinks: ["1", "5", "6",],
      bottomNavLinksClass: ["first about pull-left", "second terms pull-left", "third privacy pull-left",],

    };
  },
  componentWillMount() {
    const token = localStorage.jwtToken;
    if (token) {
      this.props.getShipment(token, this.state.activePage, this.state.per_page, this.state.status, this.state.range);
    }
    // else {
    //   <SignInContainer />;
    // }
    this.props.getCopyrightYear();
    $('#SCTitle').text("Track Your Package | ShippingCart");
  },
  componentWillReceiveProps(nextProps) {
    window.scrollTo(0, 0);
  },
  onChangeDate(event) { //change SPAN OF TIME (60 days, 2016,2017, etc)
    const token = localStorage.jwtToken;
    this.setState({ range: event.target.value, }, function () {
      this.props.getShipment(token, this.state.activePage, this.state.per_page, this.state.status, this.state.range);
    });
  },
  handleSelect(eventKey) { //handle pagination data
    const token = localStorage.jwtToken;
    localStorage.setItem('page', eventKey);
    this.setState({ activePage: eventKey, }, () => { this.props.getShipment(token, this.state.activePage, this.state.per_page, this.state.status, this.state.range) });
  },
  handleStatuses(shipment_status, type, payment_status) {
    var str = shipment_status === "canceled" && payment_status === "rejected" ? payment_status :  shipment_status;

    if (str) {
      if (type === "class") {
        switch (str) {
          case "confirmed":
          case "for_pickup":
          case "consolidated":
          case "for_consolidation":
            return "paid";
          case "failed_pickup":
          case "in_transit":
          case "out_for_delivery":
          case "failed_delivery":
          case "return_in_transit":
          case "returned":
          case "failed_return":
          case "for_acceptance":
          case "accepted":
          case "received_at_pickup_hub":
          case "received_at_delivery_hub":
          case "for_return":
          case "received_at_delivery_area":
          case "at_sorting_center":
          case "in_transit_to_delivery_area":
          case "transferred_to_partner":
          case "for_transfer":
          case "out_for_return":
          case "for_dropoff":
          case "dropped_off":
          case "dws_update":
            return "transit";
          case "canceled":
          case "rejected":
            return "cancelled"
          case "delivered":
          case "claimed":
          case "picked_up":
            return "delivered";
          default:
            return str.replace("_", "-");
        }
      } else if (type === "text") {
        switch (str) {
          case "confirmed":
          case "for_pickup":
          case "consolidated":
          case "for_consolidation":
            return "PREPARING FOR SHIPMENT";
          case "failed_pickup":
          case "in_transit":
          case "out_for_delivery":
          case "failed_delivery":
          case "return_in_transit":
          case "returned":
          case "failed_return":
          case "for_acceptance":
          case "accepted":
          case "received_at_pickup_hub":
          case "received_at_delivery_hub":
          case "for_return":
          case "received_at_delivery_area":
          case "at_sorting_center":
          case "in_transit_to_delivery_area":
          case "transferred_to_partner":
          case "for_transfer":
          case "out_for_return":
          case "for_dropoff":
          case "dropped_off":
          case "dws_update":
            return "ON ITS WAY";
          case "canceled":
            return "CANCELLED"
          case "delivered":
          case "claimed":
          case "picked_up":
            return "DELIVERED";
          default:
            return str.replace("_", " ").toUpperCase();
        }
      }
    }
    return str;
  },
  handleDate(date) {

    if (date) {
      var sliced_date = date.slice(0, 10);
      var split_date = sliced_date.split("-");
      var new_date = split_date[1] + "/" + split_date[2] + "/" + split_date[0].substring(2, 4)

      return new_date;
    }
    else { return null; }
  },
  componentWillUnmount() {
    localStorage.removeItem("trackPackage2");
  },
  render() {
    return (
      <div>
        <Header
          isAuthenticated={true}
          login={this.props.login}
          logout={this.props.logout}
        />
        <div className="body-wrapper">
          <div className="trackpackage">
            <div className="container">
              <div className="clearfix">
                <h1 className="pull-left">Track your package</h1>
                <div className="pull-right">
                  <span className="track-count">{this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.total : null} Shipments in</span>
                  <div className="select-gradient disInline">
                    <select onChange={this.onChangeDate}>
                      <option value="3months">Last 3 Months</option>
                      <option value="6months">Last 6 Months</option>
                      <option value={new Date().getFullYear()}>{new Date().getFullYear()}</option>
                      <option value={new Date().getFullYear()-1}>{new Date().getFullYear()-1}</option>
                    </select>
                  </div>
                </div>
              </div>

              <table>
                <thead className={this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.data ? "" : "hide" : null}>
                  <tr>
                    <th>Transaction Date</th>
                    <th>Tracking #</th>
                    <th>Items</th>
                    <th>Shipping Method</th>
                    <th>ShippingCart
                      <br /> Fee Total</th>
                    <th>From</th>
                    <th>Status</th>
                  </tr>
                </thead>
                  {this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.data ?
                  this.props.shipmentInfo.shipment.data.filter(ship => ship.payment_reference_id !== "").map((ship, i) =>
                    <tbody key={i}>
                      <tr className="table-row">
                        <td>{format(new Date((ship.tat.pending) * 1000), 'MM/DD/YYYY')}</td>
                        <td>{ship.tracking_number}</td>
                        <td>{ship.items.map((item, i) => item.type === "product" ?
                          <p key={i}>{item.description}</p> : null)}</td>
                        <td>{ship.shipment.includes('air') ? "Air" : "Sea"} Cargo</td>

                        <td>{ship.currency === "USD" ? "USD" : "₱"} {numbersWithComma(Number(ship.total).toFixed(2))}</td>
                        <td>{maskLocationName(ship.pickup_address.country.code)} Warehouse</td>
                        <td>
                          <label className={this.handleStatuses(ship.status, "class")}>{this.handleStatuses(ship.status, "text").toUpperCase()}</label>
                          <br/>
                          <br/>
                          {this.handleStatuses(ship.status, "text") === "PREPARING FOR SHIPMENT" ?
                            "Your package is being processed for shipping."
                          :
                            <Link to={"/tracking/" + ship.tracking_number}>Track</Link>
                          }
                        </td>
                      </tr>
                      {/* SPLITBOX */}
                      {ship.children && ship.children.length !== 0 ?
                        ship.children.map((child, i) =>
                        <tr className="table-row" key={i}>
                          <td>{this.handleDate(ship.created_at)}</td>
                          <td>{child.tracking_number}</td>
                          <td>{child.items.map((item, i) => item.type === "product" ?
                            <p key={i}>{item.description}</p> : null)}</td>
                          <td>{ship.shipment.includes('air') ? "Air" : "Sea"} Cargo</td>

                          <td>{ship.currency === "USD" ? "USD" : "₱"} {ship.total}</td>
                          <td>{maskLocationName(ship.pickup_address.country.code)} Warehouse</td>
                          <td>
                            <label className={this.handleStatuses(child.status, "class")}>{this.handleStatuses(child.status, "text").toUpperCase()}</label>
                            <br/>
                            <br/>
                            {child.status === "confirmed" ||  child.status === "consolidated" || child.status === "for_pickup" || child.status === "for_consolidation" ?
                              "Your package is being processed for shipping."
                            :
                              <Link to={"/tracking/" + child.tracking_number}>Track</Link>
                            }
                          </td>
                        </tr>
                        )
                      : null}
                    </tbody>

                  ) : <div className="no-result">No Results Found</div> : null}

              </table>
              {this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.from == null ? null :

                <Pagination prev next ellipsis boundaryLinks items={this.props.shipmentInfo.fetched ? this.props.shipmentInfo.shipment.last_page : null} maxButtons={5} activePage={this.state.activePage} onSelect={this.handleSelect} /> : null}

            </div>
          </div>

        </div>

        <Footer currentYear={this.props.login.year}/>

      </div>
    )
  },
});

export default TrackPackage;



/** WEBPACK FOOTER **
 ** ./src/components/TrackPackage.js
 **/